module.exports = __webpack_public_path__ + "img/11.1.de3901e2.jpg";